import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert, Button,
  Card,
  Col, Collapse,
  Form,
  Input,
  Layout,
  Modal,
  notification,
  Popconfirm,
  Radio,
  Row,
  Space, Tooltip,
  Typography,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomButton, CustomSelector } from '../../../components';
import {
  createPersons,
  deactivatePersons,
  getProjectsActive,
  getCharges,
  ajaxTablePersons as filterPerson,
  ajaxTableUsers as filterUsers,
} from '../../../api/module/project_person';
import AjaxTable from '../../../components/AjaxTable';
import { getProfileSelector } from '../../../api/module/profile';
import MESSAGES from '../../../enums/Messages';
import { catchException } from '../../../utils/helpers/helpers';
import { SearchOutlined, UserDeleteOutlined, WarningOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function ProjectPersonList({ match, history }) {
  const [selectedProject, setSelectedProject] = useState(undefined);
  const [contractPosition, setContractPosition] = useState(undefined);
  const [isSearch, setIsSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [selectorKey, setSelectorKey] = useState(Date.now());
  const [queryUsers, setQueryUsers] = useState(undefined);
  const [queryPersons, setQueryPersons] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [records, setRecords] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [reloadPerson, setReloadPerson] = useState(false);
  const [loadingAssign, setLoadingAssign] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Personas - Proyectos',
    },
  ];

  const columnsUser = [
    {
      title: 'Nombre completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
    },
    {
      title: 'Tipo doc',
      dataIndex: 'tipo_documento',
      key: 'tipo_documento',
    },
    {
      title: 'Documento identificación',
      dataIndex: 'numero_identificacion',
      key: 'numero_identificacion',
    },
    {
      title: 'Perfil asignado',
      dataIndex: 'perfil_proyecto',
      key: 'perfil_proyecto',
    },
    {
      title: 'Proyecto contrato',
      dataIndex: 'proyecto',
      key: 'proyecto',
    },
    {
      title: 'Cargo contrato',
      dataIndex: 'cargo',
      key: 'cargo',
    },
    {
      title: 'País',
      dataIndex: 'notificacion_pais',
      key: 'notificacion_pais',
    },
    {
      title: 'Departamento',
      dataIndex: 'notificacion_ciudad',
      key: 'notificacion_ciudad',
    },
    {
      title: 'Municipio',
      dataIndex: 'notificacion_estado',
      key: 'notificacion_estado',
    },
    {
      title: 'Correo electrónico',
      dataIndex: 'notificacion_email',
      key: 'notificacion_email',
    },
  ];

  const columnsPerson = [
    {
      title: 'Nombre completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
    },
    {
      title: 'Documento identificación',
      dataIndex: 'numero_identificacion',
      key: 'numero_identificacion',
    },
    {
      title: 'Perfil asignado',
      dataIndex: 'perfil_nombre',
      key: 'perfil_nombre',
    },
    {
      title: 'Contrato vinculado',
      dataIndex: 'contrato_nombre',
      key: 'contrato_nombre',
    },
    {
      title: 'Cargo contrato',
      dataIndex: 'cargo',
      key: 'cargo',
    },
    {
      title: 'País',
      dataIndex: 'notificacion_pais',
      key: 'notificacion_pais',
    },
    {
      title: 'Departamento',
      dataIndex: 'notificacion_ciudad',
      key: 'notificacion_ciudad',
    },
    {
      title: 'Municipio',
      dataIndex: 'notificacion_estado',
      key: 'notificacion_estado',
    },
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 125,
      render: (_, record) => (
        <Space>
          <Tooltip title='Desvincular Persona del proyecto' placement='top'>
            <Popconfirm
              title="Desvincular Contratista"
              description='Está seguro de desvincular la persona del proyecto ?'
              onConfirm={() => confirm(record)}
              icon={<WarningOutlined style={{ color: 'red' }} />}
            >
              <UserDeleteOutlined style={{ fontSize: '18px', color: 'red' }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  // TODO: optimizar la forma en la que se maneja la selección de registros
  const rowSelection = useMemo(
    () => ({
      fixed: 'left',
      selectedRowKeys: selectedRowKeys,
      onChange: (newSelectedRowKeys, newSelectedRows) => {
        const updatedRecords = [...records];
        newSelectedRows.forEach((row) => {
          if (
            row &&
            row.perfil_proyecto === null &&
            !updatedRecords.some((r) => r.key === row.key)
          ) {
            updatedRecords.push(row);
          }
        });
        setSelectedRowKeys((prevKeys) => [
          ...new Set([...prevKeys, ...newSelectedRowKeys]),
        ]);
        setRecords(updatedRecords);
      },
      onSelect: (record, selected) => {
        if (record && record.perfil_proyecto === null) {
          const updatedRecords = selected
            ? [...records, record]
            : records.filter((row) => row.key !== record.key);
          const updatedRowKeys = selected
            ? [...selectedRowKeys, record.key]
            : selectedRowKeys.filter((key) => key !== record.key);
          setSelectedRowKeys(updatedRowKeys);
          setRecords(updatedRecords);
        }
      },
      onSelectAll: (selected, newSelectedRows, changeRows) => {
        const filteredRows = newSelectedRows.filter(
          (row) => row && row.perfil_proyecto === null,
        );
        const updatedRecords = selected
          ? [
              ...records,
              ...filteredRows.filter(
                (row) => !records.some((r) => r.key === row.key),
              ),
            ]
          : records.filter((row) => !changeRows.some((r) => r.key === row.key));
        const updatedRowKeys = selected
          ? [
              ...new Set([
                ...selectedRowKeys,
                ...filteredRows.map((row) => row.key),
              ]),
            ]
          : selectedRowKeys.filter(
              (key) => !changeRows.some((row) => row.key === key),
            );
        setSelectedRowKeys(updatedRowKeys);
        setRecords(updatedRecords);
      },
      getCheckboxProps: (record) => ({
        disabled: record ? record.perfil_proyecto !== null : true, // Deshabilita el checkbox si tiene perfil_proyecto
      }),
    }),
    [selectedRowKeys, records],
  );

  const confirm = async (record) => {
    try {
      await deactivatePersons(record.id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      setReloadPerson(true);
    } catch (error) {
      catchException(error);
    }
  };

  const onFinish = async (values) => {
    setIsSearch(true);
    setLoading(true);

    const queryParams = {
      project_id: selectedProject,
      linked_to_project: values.bonding,
      cargo: contractPosition,
      'filter[nombre_completo]': values.nombre,
      'filter[numero_identificacion]': values.documento,
      'filter[notificacion_email]': values.email,
      'filter[notificacion_pais]': values.country,
      'filter[notificacion_ciudad]': values.city,
      'filter[notificacion_estado]': values.state,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(queryParams).filter(([_, value]) => value !== undefined),
    );

    const query = new URLSearchParams(filteredParams).toString();
    setQueryUsers(query);
    setLoading(false);
  };

  const handleReset = (bonding = null) => {
    form.resetFields();
    form.setFieldsValue({
      bonding: bonding !== null ? bonding : 'linked_to_project',
    });
    setIsSearch(false);
    setContractPosition(undefined);
    setSelectorKey(Date.now());
    setQueryUsers('');
  };

  const resetAfterCreate = () => {
    if (selectedProject) {
      setIsSearch(false);
      setQueryUsers('');
      setSelectorKey(Date.now());
      setRecords([]);
      setSelectedRowKeys([]);

      const queryParams = {
        'filter[proyecto]': selectedProject,
      };

      const filteredParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, value]) => value !== undefined),
      );

      const query = new URLSearchParams(filteredParams).toString();
      setQueryPersons(query);
    }
  };

  useEffect(() => {
    resetAfterCreate();
  }, [selectedProject]);

  useEffect(() => {
    form.setFieldsValue({ bonding: 'linked_to_project' });
  }, []);

  const handleSelectorChange = (selectedItem) => {
    if (selectedItem) {
      setContractPosition(selectedItem);
    } else {
      setContractPosition(undefined);
    }
  };

  const handleOk = async () => {
    setLoadingAssign(true);
    if (selectedProfile) {
      const data = records.map((item) => ({
        proyecto: selectedProject,
        usuario_persona: item.id,
        perfil: selectedProfile,
        contrato: item.contrato,
      }));
      try {
        await createPersons(data);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
      } catch (error) {
        catchException(error);
      }
      setOpen(false);
      setIsSearch(false);
      resetAfterCreate();
      setReloadPerson(true);
      setLoadingAssign(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (reloadPerson) {
      setReloadPerson(false);
    }
  }, [reloadPerson]);

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Gestión de proyectos - personas
          </Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={6}>
          <Paragraph>
            Seleccione el proyecto al que va consultar/asignar personas:
          </Paragraph>
        </Col>
        <Col span={17} offset={1}>
          <CustomSelector
            selectorProps={{
              style: { width: '100%' },
              placeholder: 'Seleccione el proyecto... ',
            }}
            endpointFetch={async () => {
              return await getProjectsActive();
            }}
            onChange={(value) => setSelectedProject(value)}
          />
        </Col>
      </Row>
      {selectedProject && (
        <>
          <Row style={{ marginTop: '20px' }}>
            <Col span={24}>
              <Collapse items={[
                {
                  key: '1',
                  label: <Title level={5}>Búsqueda de personas</Title>,
                  children:
                    <Form
                      form={form}
                      name="project_person_search_form"
                      layout="vertical"
                      onFinish={onFinish}
                    >
                      <Form.Item name="bonding">
                        <Radio.Group style={{ width: '100%' }}>
                          <Row>
                            <Col span={8} style={{ whiteSpace: 'nowrap' }}>
                              <Radio value="linked_to_project">
                                Contrato activo en proyecto seleccionado
                              </Radio>
                            </Col>
                            <Col span={8} style={{ whiteSpace: 'nowrap' }}>
                              <Radio value="unlinked_to_project">
                                Sin contrato activo en proyecto seleccionado
                              </Radio>
                            </Col>
                            <Col span={8} style={{ whiteSpace: 'nowrap' }}>
                              <Radio value="all">Todos los proyectos SIGA</Radio>
                            </Col>
                          </Row>
                        </Radio.Group>
                      </Form.Item>
                      <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                        <Col span={7}>
                          <Form.Item label="Nombre y apellidos" name="nombre">
                            <Input allowClear placeholder="Búsqueda por nombre" />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item label="Documento" name="documento">
                            <Input
                              type="number"
                              allowClear
                              placeholder="Búsqueda por documento"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item label="Correo electrónico" name="email">
                            <Input
                              allowClear
                              type={'email'}
                              placeholder="Búsqueda por correo electrónico"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item noStyle dependencies={['bonding']}>
                        {({ getFieldValue }) =>
                          getFieldValue('bonding') === 'linked_to_project' ? (
                            <Row style={{ marginTop: '10px' }}>
                              <Col span={4}>
                                <Paragraph>Cargo contrato:</Paragraph>
                              </Col>
                              <Col span={20}>
                                <CustomSelector
                                  key={selectorKey}
                                  selectorProps={{
                                    style: { width: '100%' },
                                    placeholder: 'Seleccione el cargo contrato... ',
                                  }}
                                  endpointFetch={async () => {
                                    return await getCharges(selectedProject);
                                  }}
                                  onChange={setContractPosition}
                                />
                              </Col>
                            </Row>
                          ) : null
                        }
                      </Form.Item>
                      <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                        <Col span={7}>
                          <Form.Item label="País residencia" name="country">
                            <Input allowClear placeholder="Búsqueda por país" />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item label="Departamento residencia" name="city">
                            <Input
                              allowClear
                              placeholder="Búsqueda por departamento"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item label="Municipio de residencia" name="state">
                            <Input
                              allowClear
                              placeholder="Búsqueda por municipio"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item wrapperCol={{ span: 24 }}>
                        <CustomButton
                          type="primary"
                          icon={<SearchOutlined />}
                          htmlType="submit"
                          text="Buscar"
                          loading={loading}
                        />
                        <Button
                          style={{ marginLeft: '20px' }}
                          danger
                          onClick={() => handleReset()}
                        >Borrar filtros</Button>
                      </Form.Item>
                    </Form>,
                }
              ]} />
            </Col>
          </Row>
          {isSearch && queryUsers && (
            <>
              <Alert
                style={{ marginTop: '20px' }}
                message="Seleccion las personas a las cuales va a asignar a un mismo perfil para el proyecto"
                type="info"
                showIcon
              />
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <AjaxTable
                    tableTitle={'Lista de resultados'}
                    rowKey={'key'}
                    query={queryUsers}
                    columns={columnsUser}
                    searchInput={true}
                    endpoint={filterUsers}
                    rowSelection={{
                      ...rowSelection,
                    }}
                  />
                </Col>
              </Row>
              <CustomButton
                type="primary"
                htmlType="button"
                text="Asginar perfil a selección"
                disabled={selectedRowKeys.length === 0}
                onClick={() => setOpen(true)}
              />
              <Modal
                title="Asignación de personas"
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Guardar"
                cancelText="Volver"
                confirmLoading={loadingAssign}
              >
                <Row>
                  <Col span={6}>
                    <Paragraph>Perfil a asignar:</Paragraph>
                  </Col>
                  <Col span={17} offset={1}>
                    <CustomSelector
                      selectorProps={{
                        style: { width: '100%' },
                        placeholder: 'Seleccione el perfil de proyectos... ',
                      }}
                      endpointFetch={async () => {
                        return await getProfileSelector();
                      }}
                      onChange={(value) => setSelectedProfile(value)}
                    />
                  </Col>
                </Row>
              </Modal>
            </>
          )}
          {selectedProject && queryPersons && (
            <Row style={{ marginTop: '20px' }}>
              <Col span={24}>
                <AjaxTable
                  tableTitle={'Listado de contratistas asignados al proyecto'}
                  rowKey={'person'}
                  endpoint={filterPerson}
                  query={queryPersons}
                  columns={columnsPerson}
                  searchInput={true}
                  reloadSource={reloadPerson}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </Content>
  );
}
